import { SkeletonCard, SkeletonTable } from "./shimmer";

interface LoadingPageProps {
  type?: "dashboard" | "table" | "form" | "cards";
  title?: string;
}

export function LoadingPage({ type = "dashboard", title }: LoadingPageProps) {
  return (
    <div className="space-y-6">
      {title && (
        <div className="space-y-2">
          <div className="shimmer h-8 w-48 rounded" />
          <div className="shimmer h-4 w-96 rounded" />
        </div>
      )}

      {type === "dashboard" && (
        <>
          {/* Dashboard stats cards */}
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <SkeletonCard key={i} className="h-32" />
            ))}
          </div>

          {/* Chart area */}
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-7">
            <SkeletonCard className="col-span-4 h-80" />
            <SkeletonCard className="col-span-3 h-80" />
          </div>
        </>
      )}

      {type === "table" && (
        <div className="bg-card border rounded-lg p-6">
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div className="shimmer h-6 w-32 rounded" />
              <div className="shimmer h-10 w-24 rounded" />
            </div>
            <SkeletonTable rows={8} columns={5} />
          </div>
        </div>
      )}

      {type === "form" && (
        <div className="max-w-2xl space-y-6">
          <SkeletonCard className="p-6">
            <div className="space-y-4">
              {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="space-y-2">
                  <div className="shimmer h-4 w-24 rounded" />
                  <div className="shimmer h-10 w-full rounded" />
                </div>
              ))}
              <div className="flex justify-end space-x-2">
                <div className="shimmer h-10 w-20 rounded" />
                <div className="shimmer h-10 w-20 rounded" />
              </div>
            </div>
          </SkeletonCard>
        </div>
      )}

      {type === "cards" && (
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <SkeletonCard key={i} className="h-48" />
          ))}
        </div>
      )}
    </div>
  );
}
